import {
  SET_WIZARD_STEP,
  SET_WIZARD_SELECTED_ITEMS,
  CLEAR_WIZARD_SELECTED_ITEMS,
} from 'constants/actions';

function setWizardStep(step) {
  return {
    type: SET_WIZARD_STEP,
    step,
  };
}

function setWizardSelectedItems(selectedItems) {
  return {
    type: SET_WIZARD_SELECTED_ITEMS,
    selectedItems,
  };
}

function clearWizardSelectedItems() {
  return {
    type: CLEAR_WIZARD_SELECTED_ITEMS,
  };
}

export { setWizardStep, setWizardSelectedItems, clearWizardSelectedItems };
